import DashboardLayout from '../components/DashboardLayout';
import FieldLayout from '../components/FieldLayout';
import AdminLayout from '../components/AdminLayout';

// Shared pages render inside whichever division the user is currently in.
export function layoutForPath(pathname = '') {
  if (pathname.startsWith('/admin/')) return AdminLayout;
  if (pathname.startsWith('/field')) return FieldLayout;
  return DashboardLayout;
}
